export const singleFundPageStructure = [
  {
    component: 'Div',
    position: '0',
    constantProps: {
      classes: {
        value: 'lil-container',
      },
    },
    childComponent: [
      {
        component: 'BreadCrumb',
        position: '0',
        constantProps: {
          disableLastChild: {
            value: true,
          },
        },
        stateProps: {
          breadcrumbs: {
            value: ['optimizedFund.breadcrumbs', []],
          },
        },
      },
    ],
  },
  {
    component: 'SingleFundTitleNew',
    stateProps: {
      title: {
        value: 'title',
      },
      isNfo: {
        value: ['optimizedFund.isNfo', ''],
      },
      morningStar: {
        value: ['optimizedFund.morningStar', ''],
      },
      imgURL: {
        value: ['optimizedFund.image', ''],
      },
      purchaseMode: {
        value: ['optimizedFund.purchaseMode', ''],
      },
      planType: {
        value: ['optimizedFund.planType', ''],
      },
      isElss: {
        value: ['optimizedFund.isElss', ''],
      },
      risk: {
        value: ['optimizedFund.info[0].value', ''],
      },
      category: {
        value: ['optimizedFund.category', ''],
      },
      navArr: {
        value: ['optimizedFund.latestNav', ''],
      },
      returnsSinceInception: {
        value: ['optimizedFund.returns.returnSinceInception', ''],
      },
    },
    fnProps: {
      returnsLabelArr: {
        value: 'returnArr',
        parameters: ['optimizedFund.returns', 'state'],
        defaultValue: {},
      },
    },
    position: '0',
  },
  {
    component: 'Div',
    constantProps: {
      classes: {
        value:
          'lil-flex lil-container md:lil-items-start sm:lil-pb-0 sm:lil-flex-col lil-pb-4',
      },
    },
    childComponent: [
      {
        component: 'Div',
        position: '0',
        constantProps: {
          classes: {
            value: 'lil-w-2/3 sm:lil-w-full',
          },
        },
        childComponent: [
          {
            component: 'ELSS',
            stateProps: {
              title: {
                value: 'title',
              },
              isNfo: {
                value: ['optimizedFund.isNfo', []],
              },
              imgURL: {
                value: ['optimizedFund.imgURL', ''],
              },
            },
            fnProps: {
              returnsLabelArr: {
                value: 'returnArr',
                parameters: ['optimizedFund.returns', 'state'],
                defaultValue: {},
              },
            },
            position: '1',
            conditionalRender: ['optimizedFund.isElss', 'state'],
            key: 'random3',
          },
          {
            component: 'FundPerformanceChart',
            key: 'FundPerformancChart',
            stateProps: {
              fundPerformaceData: {
                value: ['optimizedFund.fundPerformaceData.all', []],
              },
              catgPerformaceData: {
                value: ['optimizedFund.catgPerformaceData.all', []],
              },
              category: {
                value: ['optimizedFund.category', []],
              },
              name: {
                value: ['optimizedFund.name', ''],
              },
            },
            position: '2',
            conditionalRender: [
              'optimizedFund.fundPerformaceData.all',
              'state',
            ],
          },
          {
            component: 'ReturnCalculator',
            stateProps: {
              returns: {
                value: ['optimizedFund.returns', []],
              },
              returnsCategory: {
                value: ['optimizedFund.returnsCategory', []],
              },
            },
            conditionalRender: ['optimizedFund.returns', 'state'],
            position: '7',
          },
          {
            component: 'NfoOverview',
            stateProps: {
              nfoState: {
                value: ['optimizedFund.nfoDetails', ''],
              },
              nfoCloseDate: {
                value: ['optimizedFund.nfoCloseDate', ''],
              },
              nfoCloseDay: {
                value: ['optimizedFund.nfoCloseDay', ''],
              },
              nav: {
                value: ['optimizedFund.nav', ''],
              },
              allotmentDate: {
                value: ['optimizedFund.allotmentDate', ''],
              },
              openDate: {
                value: ['optimizedFund.openDate', ''],
              },
            },
            conditionalRender: ['optimizedFund.isNfo', 'state'],
            position: '3',
          },
          {
            component: 'FundOverView',
            stateProps: {
              fundData: {
                value: ['optimizedFund', {}],
              },
            },
            props: {
              isMobile: {
                value: 'isMobile',
              },
            },
            position: '4',
          },
          // {
          //   component: 'Div',
          //   constantProps: {
          //     classes: {
          //       value:
          //         'lil-w-full lil-pl-12 lil-pt-12 md:lil-pt-6 sm:lil-pt-4  xl:lil-hidden lg:lil-hidden md:lil-hidden sm:lil-p-0',
          //     },
          //   },
          //   conditionalRender: ['optimizedFund', 'state'],
          //   childComponent: [
          //     {
          //       component: 'InvestAmount',
          //       stateProps: {
          //         data: {
          //           value: ['optimizedFund', {}],
          //         },
          //         investmentType: {
          //           value: 'investmentType',
          //         },
          //         amount: {
          //           value: 'amount',
          //         },
          //         minAmount: {
          //           value: 'minAmount',
          //         },
          //         maxAmount: {
          //           value: 'maxAmount',
          //         },
          //         investInView: {
          //           value: 'investInView',
          //         },
          //         callbackRequested: {
          //           value: 'callbackRequested',
          //         },
          //         isMaxAmountExceed: {
          //           value: 'isMaxAmountExceed',
          //         },
          //         isMonthlyLimitExceed: {
          //           value: 'isMonthlyLimitExceed',
          //         },
          //       },
          //       fnProps: {
          //         visibilityChange: {
          //           value: 'visibilityChange',
          //         },
          //         onChange: {
          //           value: 'onChange',
          //         },
          //         onAmountChangeBlur: {
          //           value: 'onAmountChangeBlur',
          //         },
          //         investClick: {
          //           value: 'investClick',
          //         },
          //         callback: {
          //           value: 'callback',
          //         },
          //         dismissModal: {
          //           value: 'dismissModal',
          //         },
          //         getSelectedAmt: {
          //           value: 'getSelectedAmt',
          //         },
          //       },
          //       props: {
          //         hasUserInvestedInProduct: {
          //           value: 'hasUserInvestedInProduct',
          //         },
          //       },
          //     },
          //   ],
          //   position: '5',
          // },
          {
            component: 'FundDistribution',
            stateProps: {
              assetAllocation: {
                value: ['optimizedFund.assetAllocation', []],
              },
            },
            position: '5',
          },
          {
            component: 'HoldingsAndSectors',
            stateProps: {
              holdings: {
                value: ['optimizedFund.holdings', []],
              },
              sectors: {
                value: ['optimizedFund.sectors', []],
              },
              assetAllocation: {
                value: ['optimizedFund.assetAllocation', []],
              },
            },
            fnProps: {
              investClick: {
                value: 'investClick',
              },
            },
            conditionalRender: ['optimizedFund.holdings', 'state'],
            position: '6',
          },
          // {
          //   component: 'TopSectors',
          //   stateProps: {
          //     sectors: {
          //       value: ['optimizedFund.sectors', []],
          //     },
          //   },
          //   conditionalRender: ['optimizedFund.sectors', 'state'],
          //   position: '8',
          // },
          {
            props: ['isMobile'],
            component: 'PeerComparison',
            stateProps: {
              similarFunds: {
                value: ['optimizedFund.similarFunds', []],
              },
              alpha: {
                value: ['optimizedFund.alpha1Y', ''],
              },
            },
            conditionalRender: ['optimizedFund.similarFunds', 'state'],
            position: '9',
          },
          {
            component: 'KeyRatio',
            stateProps: {
              insights: {
                value: ['optimizedFund.insights.insights', []],
              },
            },
            conditionalRender: ['optimizedFund.insights.insights', 'state'],
            position: '10',
          },
          {
            component: 'NAVHistory',
            stateProps: {
              name: {
                value: ['optimizedFund.name', []],
              },
              latestNav: {
                value: ['optimizedFund.latestNav', []],
              },
              returns: {
                value: ['optimizedFund.returns', []],
              },
              category: {
                value: ['optimizedFund.category', []],
              },
              subCategory: {
                value: ['optimizedFund.subCategory', []],
              },
              fundManagers: {
                value: ['optimizedFund.fundManagers', []],
              },
              minAmount: {
                value: ['optimizedFund.minAmount', []],
              },
              minSipAmount: {
                value: ['optimizedFund.minSipAmount', []],
              },
              exitLoadDetail: {
                value: ['optimizedFund.exitLoadDetail', []],
              },
              inceptionDate: {
                value: ['optimizedFund.inceptionDate', []],
              },
              fundType: {
                value: ['optimizedFund.fundType', []],
              },
            },
            position: '11',
          },
          {
            component: 'AboutFund',
            stateProps: {
              fundManagers: {
                value: [
                  'optimizedFund.collapsibleInfo.fundManagerAndAMC.fundManager',
                  [],
                ],
              },
              amcDetail: {
                value: [
                  'optimizedFund.collapsibleInfo.fundManagerAndAMC.amc',
                  {},
                ],
              },
            },
            conditionalRender: [
              'optimizedFund.collapsibleInfo.fundManagerAndAMC',
              'state',
            ],
            position: '12',
          },
          {
            component: 'FAQNew',
            stateProps: {
              faqs: {
                value: ['optimizedFund.faqs', []],
              },
            },
            conditionalRender: ['optimizedFund.faqs', 'state'],
            position: '13',
          },
          // {
          //   component: 'TestimonialsSection',
          //   constantProps: {
          //     SECTION_TESTIMONIALS: {
          //       value: [
          //         {
          //           text: ' Great investing experience! Contacted the support with queries.. Got immediate response and all my doubts clarified. Will definitely recommend ClearTax to friends ',
          //           image:
          //             'https://d2s63alnkuz6gf.cloudfront.net/assets/website/landing_page/testimonials/nandita_saini.jpg',
          //           author: 'NANDITA SAINI',
          //           place: 'BANGALORE, KARNATAKA',
          //         },
          //         {
          //           text: ' I am new to investments and got all the information I need on your website. The suggestions for mutual fund investments and tax savings are great. ',
          //           image:
          //             'https://d2s63alnkuz6gf.cloudfront.net/assets/website/landing_page/testimonials/jyotsna_paul.jpg',
          //           author: 'JYOTSNA PAUL',
          //           place: 'BANGALORE, KARNATAKA',
          //         },
          //         {
          //           text: 'I have been using cleartax for investment from last 3 years ! Very effective and easy to use !',
          //           image:
          //             'https://d2s63alnkuz6gf.cloudfront.net/assets/website/landing_page/testimonials/manmohan.jpg',
          //           author: 'MANMOHAN MEHRA',
          //           place: 'BANGALORE, KARNATAKA',
          //         },
          //         {
          //           text: ' Investing through ClearTax is super easy and simple. It is extremely helpful for investors with less finance knowledge. ',
          //           image:
          //             'https://d2s63alnkuz6gf.cloudfront.net/assets/website/landing_page/testimonials/chethan.jpg',
          //           author: 'CHETHAN ELVIS DAS',
          //           place: 'CHENNAI, TAMILNADU',
          //         },
          //       ],
          //     },
          //     wrapperClass: {
          //       value: 'lil-w-2/3',
          //     },
          //   },
          //   position: '12',
          // },
        ],
      },
      {
        component: 'Div',
        constantProps: {
          classes: {
            value:
              'lil-w-1/3 lil-pl-12 lil-pt-12 md:lil-pt-6 sm:lil-pt-4  sm:lil-hidden sm:lil-p-0',
          },
          styles: {
            value: {
              position: 'sticky',
              top: '6rem',
              'align-self': 'flex-start',
            },
          },
        },
        childComponent: [
          {
            position: '0',
            component: 'InvestAmount',
            stateProps: {
              data: {
                value: ['optimizedFund', {}],
              },
              investmentType: {
                value: 'investmentType',
              },
              amount: {
                value: 'amount',
              },
              minAmount: {
                value: 'minAmount',
              },
              maxAmount: {
                value: 'maxAmount',
              },
              investInView: {
                value: 'investInView',
              },
              callbackRequested: {
                value: 'callbackRequested',
              },
              isMaxAmountExceed: {
                value: 'isMaxAmountExceed',
              },
              isMonthlyLimitExceed: {
                value: 'isMonthlyLimitExceed',
              },
            },
            fnProps: {
              visibilityChange: {
                value: 'visibilityChange',
              },
              onChange: {
                value: 'onChange',
              },
              onAmountChangeBlur: {
                value: 'onAmountChangeBlur',
              },
              investClick: {
                value: 'investClick',
              },
              callback: {
                value: 'callback',
              },
              dismissModal: {
                value: 'dismissModal',
              },
              getSelectedAmt: {
                value: 'getSelectedAmt',
              },
            },
            props: {
              hasUserInvestedInProduct: {
                value: 'hasUserInvestedInProduct',
              },
            },
          },
        ],
        position: '1',
        conditionalRender: ['optimizedFund', 'state'],
      },
    ],
    position: '1',
  },
  // {
  //   component: 'WhyCleartaxNew',
  //   constantProps: {
  //     Heading: {
  //       value: 'SubHeading',
  //       isComponent: true,
  //     },
  //     title: {
  //       value: 'Why Invest with ClearTax',
  //     },
  //   },
  //   position: '2',
  // },
  // {
  //   component: 'StepsToInvest',
  //   position: '3',
  // },
  {
    component: 'InvestNow',
    position: '5',
    fnProps: {
      investClicked: {
        value: 'investClicked',
      },
    },
    conditionalRender: ['showStickyInvest', 'state'],
  },
];



// WEBPACK FOOTER //
// ./constants/singleFundPageStructure.ts